import styled from '@emotion/styled';
import { colors } from 'theme/colors';

interface StyledFieldProps {
  disabled?: boolean;
  code?: boolean;
}

export const StyledField = styled.div<StyledFieldProps>(({ disabled, code }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  width: 'fit-content',
  overflow: 'hidden',
  gap: '4px',
  input: {
    height: '32px',
    backgroundColor: `${colors.white}`,
    boxSizing: 'border-box',
    ...(disabled ? { backgroundColor: colors.gray100 } : {}),
    borderRadius: '4px',
    border: `1px solid ${colors.gray400}`,
    padding: '8px',
    MozAppearance: 'textfield',
    WebkitAppearance: 'none',
    appearance: 'textfield',
    width: '80px',
    textAlign: 'center',
    justifyItems: 'center',
  },
  button: {
    width: '32px',
    height: '32px',
    borderRadius: '4px',
    borderWidth: '1px',
    border: `1px solid ${colors.gray400}`,
    background: colors.white,
    fontSize: '18px',
  },
  '& .MuiOutlinedInput-root': {
    ...(code ? { width: '50px', padding: '15px 0' } : {}),
    marginBottom: 3,
    backgroundColor: `${colors.white}`,
    '& fieldset': {
      borderColor: colors.gray400,
      borderWidth: '1px',
    },

    '&:hover:not(.Mui-focused) fieldset': {
      borderColor: colors.primary400,
    },

    '&.Mui-focused fieldset': {
      borderColor: colors.primary400,
      borderWidth: '2px',
    },

    '&:active fieldset': {
      borderColor: colors.primary900,
      borderWidth: '1px',
    },

    '&.Mui-error fieldset': {
      borderColor: colors.error800,
      borderWidth: '1px',
    },
    '& ~ p': {
      marginLeft: '0px',
    },
  },
}));
